import { useEffect, useRef } from "react";

export default function AnimatedCursor() {
  const dot = useRef(null);
  const ring = useRef(null);
  const mouse = useRef({ x: 0, y: 0 });
  const pos = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const onMove = (e) => {
      mouse.current.x = e.clientX;
      mouse.current.y = e.clientY;
      if (dot.current) {
        dot.current.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0)`;
      }
    };

    const render = () => {
      pos.current.x += (mouse.current.x - pos.current.x) * 0.15;
      pos.current.y += (mouse.current.y - pos.current.y) * 0.15;
      if (ring.current) {
        ring.current.style.transform = `translate3d(${pos.current.x}px, ${pos.current.y}px, 0)`;
      }
      requestAnimationFrame(render);
    };

    document.addEventListener("mousemove", onMove, { passive: true });
    render();
    return () => document.removeEventListener("mousemove", onMove);
  }, []);

  useEffect(() => {
    const onEnter = () => {
      if (ring.current) ring.current.style.transform += " scale(1.25)";
    };
    const onLeave = () => {
      if (ring.current) ring.current.style.transform = ring.current.style.transform.replace(
        / scale\([^)]+\)/,
        ""
      );
    };
    document.querySelectorAll("a, button, .cursor-interactive").forEach((el) => {
      el.addEventListener("mouseenter", onEnter);
      el.addEventListener("mouseleave", onLeave);
    });
    return () => {
      document.querySelectorAll("a, button, .cursor-interactive").forEach((el) => {
        el.removeEventListener("mouseenter", onEnter);
        el.removeEventListener("mouseleave", onLeave);
      });
    };
  }, []);

  return (
    <>
      <div
        ref={ring}
        className="pointer-events-none fixed left-0 top-0 z-[100] h-8 w-8 -translate-x-1/2 -translate-y-1/2 rounded-full border border-neon-mint/60 mix-blend-difference transition-transform duration-150 ease-out"
      />
      <div
        ref={dot}
        className="pointer-events-none fixed left-0 top-0 z-[100] h-1.5 w-1.5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-neon-mint mix-blend-difference"
      />
    </>
  );
}